import Section from '@components/common/Section/Section'
import SublimeMedia from '@components/common/SublimeMedia/SublimeMedia'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import { MediaPicker } from '@customTypes/mediaPicker'
import { FC } from 'react'

import styles from './ImageComponent.module.scss'

type ImageProps = {
  image?: MediaPicker
  embeddedContent?: string
}

const ImageComponent: FC<ImageProps> = ({ image, embeddedContent }) => {
  return (
    <Section className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.imageContainer}>
          {!embeddedContent && image && (
            <SublimeMedia
              mediaPicker={image}
              className={styles.swiperImage}
              layout="responsive"
              objectFit="cover"
            />
          )}
          {embeddedContent && <TrustedHtml html={embeddedContent} />}
        </div>
      </div>
    </Section>
  )
}

export default ImageComponent
